import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 5000 : 8000;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, city, plan] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-156" data-mp="drhx0ndveqfr">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-4 left-4 z-[60] max-w-[300px] overflow-hidden rounded-2xl border-2 border-rose-soft bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(109,40,217,.45)]" aria-live="polite" data-id="element-157" data-mp="dtcflv1o66go">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-rose" data-id="element-158" data-mp="11gaqmd70sm77" />
            <div className="absolute right-0 top-0 h-12 w-12 rounded-bl-full bg-rose-soft/25" data-id="element-159" data-mp="15jgwvku4uddo" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-violet-200 transition-colors duration-150 hover:text-white" aria-label="Cerrar notificación" data-id="element-160" data-mp="1agqxlwmz2bgt">
              <XIcon className="h-3.5 w-3.5" data-id="element-161" data-mp="32h8rqvun6em9" />
            </button>
            <div className="flex gap-3" data-id="element-162" data-mp="3gc1as49qqcxl">
              <span className="h-fit rounded-full border-2 border-pink-100 bg-rose p-2 text-white shadow-sm" data-id="element-163" data-mp="3bjq9awzcqj2x">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-164" data-mp="3q84o86a1lxzu" />
              </span>
              <div data-id="element-165" data-mp="3qah50g42e2bb">
                <p className="flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-rose-soft" data-id="element-166" data-mp="3l9tb9mogb7de">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-167" data-mp="32vk2kbh8x7b" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-violet-50" data-id="element-168" data-mp="3ubarr65rtb2m">
                  <b className="text-white" data-id="element-169" data-mp="24v1jnbz4q455">{name}</b> compró el libro digital{' '}
                  <b className="text-pink-200" data-id="element-170" data-mp="24x4i8kecl5lh">{plan}</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-medium text-violet-200" data-id="element-171" data-mp="1zy1dl12a51e1">
                  <MapPinIcon className="h-3 w-3 text-rose-soft" data-id="element-172" data-mp="fexuaqcbzk36" />
                  {city} · Argentina · hace {index * 6 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-173" data-mp="amxq2lp8a50s">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center font-display text-sm font-bold text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-174" data-mp="alwbw8cx12eu">
            QUIERO MI COMBO DE MOVILIDAD →
          </motion.a>}
      </AnimatePresence>
    </>;
}